function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1668",
  "data-name": "Group 1668",
  transform: "translate(-222 -92)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_39",
  "data-name": "Line 39",
  x2: 10,
  transform: "translate(222.5 92.5)",
  fill: "none",
  stroke: "#25a4b4",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_40",
  "data-name": "Line 40",
  x2: 10,
  transform: "translate(222.5 95.5)",
  fill: "none",
  stroke: "#25a4b4",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_41",
  "data-name": "Line 41",
  x2: 10,
  transform: "translate(222.5 98.5)",
  fill: "none",
  stroke: "#25a4b4",
  strokeLinecap: "round",
  strokeWidth: 1
}));

var SvgCollapsedMenu = function SvgCollapsedMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCollapsedMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/collapsed-menu.09d0b15d.svg";
export { ForwardRef as ReactComponent };